import moment from 'moment/moment'

import { FileUpload, RadioButton, Select, TextInput } from 'Components/Form'
import { pickupType } from 'Utils/helper'

export default function Accept({ view, values, touched, errors, setFieldValue, affiliates = [], storages = [], display = true }) {
    return (
        <>
            <TextInput
                type="datetime-local"
                id="pickup_date"
                name="pickup_date"
                label="Pickup Date"
                error={touched?.pickup_date && errors?.pickup_date}
                onChange={e => setFieldValue('pickup_date', moment(e.target.value).locale('en').format('YYYY-MM-DD HH:mm'))}
                // min={moment().format('YYYY-MM-DD HH:mm')}
            />
            <TextInput
                id="pickup_by"
                name="pickup_by"
                label="Transport Company"
                error={touched?.pickup_by && errors?.pickup_by}
                onChange={e => setFieldValue('pickup_by', e.target.value)}
            />
            <TextInput
                id="manifest_no"
                name="manifest_no"
                label="Manifest No"
                error={touched?.manifest_no && errors?.manifest_no}
                onChange={e => setFieldValue('manifest_no', e.target.value)}
            />
            <RadioButton
                group
                name="type"
                datas={pickupType()}
                value={values.type ?? 0}
                label="Type"
                className="grid grid-cols-2 gap-3"
                error={touched?.type && errors?.type}
                disabled={!display}
            />
            {(values.type ?? 0).toString() === '0' ? (
                <Select
                    id="affiliate_id"
                    name="affiliate_id"
                    label="Affiliate"
                    placeholder="Affiliate"
                    value={values.affiliate_id}
                    options={affiliates.map(e => ({
                        id: e.id,
                        label: e.business_name,
                    }))}
                    onChange={e => setFieldValue('affiliate_id', e.target.value)}
                    error={touched?.affiliate_id && errors?.affiliate_id}
                />
            ) : (
                <Select
                    id="storage_id"
                    name="storage_id"
                    label="Storage"
                    placeholder="Storage"
                    value={values.storage_id}
                    options={storages.map(e => ({
                        id: e.id,
                        label: e.name,
                    }))}
                    onChange={e => setFieldValue('storage_id', e.target.value)}
                    error={touched?.storage_id && errors?.storage_id}
                />
            )}
            <FileUpload
                id="documents"
                name="documents"
                error={errors?.documents}
                label="Documents"
                onChange={e => setFieldValue('documents', Array.from(e.target.files))}
                multiple
                documentLists={(view?.document_urls ?? []).filter(e => !values.document_remove.includes(e.file_name))}
                removeDocument={img => {
                    var document_remove = values.document_remove
                    document_remove.push(img.file_name)
                    setFieldValue('document_remove', document_remove)
                }}
            />
        </>
    )
}
